import volunteers from './volunteers'

const fakeData =[...volunteers]

export default fakeData;